import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
export default class PlansController extends Controller {
  @service session;
  get user() {
    return this.session?.user;
  }
}
